// Phone / WhatsApp number checks for every form on the site.
// The server applies the same rules (server/utils/phone.js); keep them in sync.
//
// Accepts:
//  - Indian mobiles: 10 digits starting 6-9, optionally with +91, 91 or 0 in front
//  - International numbers: + and country code, 8-15 digits in total
// Spaces, dashes, dots and brackets are ignored.
// Returns the number in E.164 form (e.g. +919876543210), or null if it isn't valid.
export const normalizePhone = (value) => {
  if (typeof value !== 'string') return null;
  const trimmed = value.trim();
  if (!/^\+?[\d\s\-().]+$/.test(trimmed)) return null;

  const hasPlus = trimmed.startsWith('+');
  const digits = trimmed.replace(/\D/g, '');
  const indianMobile = /^[6-9]\d{9}$/;

  if (hasPlus) {
    if (digits.startsWith('91')) return indianMobile.test(digits.slice(2)) ? `+${digits}` : null;
    return /^[1-9]\d{7,14}$/.test(digits) ? `+${digits}` : null;
  }
  if (indianMobile.test(digits)) return `+91${digits}`;
  if (/^91[6-9]\d{9}$/.test(digits)) return `+${digits}`;
  if (/^0[6-9]\d{9}$/.test(digits)) return `+91${digits.slice(1)}`;
  return null;
};

export const PHONE_ERROR = 'Please enter a valid mobile number: 10 digits, or + and your country code.';

// Only digits and the usual separators, for filtering what people type
export const PHONE_ALLOWED = /^[+\d\s\-().]*$/;
